module.exports = __webpack_public_path__ + "img/dashboardd.6041c18f.svg";